import {
    CaseReducer,
    PayloadAction,
} from '@reduxjs/toolkit'
import {
    NinchatProperties,
    NinchatState,
} from 'api/types'

type JoinPermissionGroupFulfilledAction = PayloadAction<unknown, string, {
    arg: {realm_id: NinchatProperties.RealmID}
}>

const isAck = (value: unknown): boolean => {
    if (typeof value !== 'object' || value === null || !('event' in value)) {
        return false
    }

    return value.event === 'ack' || isAck(value.event)
}

export const joinPermissionGroupAck: CaseReducer<NinchatState, JoinPermissionGroupFulfilledAction> = (state, action) => {
    const replies = Array.isArray(action.payload) ? action.payload : [action.payload]
    if (!replies.some(isAck)) {
        return
    }

    const {realm_id: realmId} = action.meta.arg
    const permissions = state.session_realms_permissions[realmId] ?? []
    const missingPermissions = NinchatProperties.ADMIN_PERMISSIONS.filter((permission) => !permissions.includes(permission))
    state.session_realms_permissions[realmId] = [...permissions, ...missingPermissions]
}
